import MoneyBackGuaranteeModal from './MoneyBackGuaranteeModal';

export default MoneyBackGuaranteeModal;
